import { firestore } from "../../config/firebase";
import * as actionTypes from "../actions/actionTypes";

export const fetchUserData = (id) => {
  return (dispatch) =>
    firestore
      .collection("users")
      .doc(id)
      .get()
      .then((snapshot) => {
        const userData = snapshot.data();
        dispatch({
          type: actionTypes.FETCH_USER_DATA,
          payload: userData,
        });
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.FETCH_USER_DATA_FAIL,
          payload: err,
        });
      });
};
